// extracted by mini-css-extract-plugin
export default {"video-player-overlay":"VideoPlayer_video-player-overlay__CCQFm","video-player-container":"VideoPlayer_video-player-container__NrEdJ","video":"VideoPlayer_video__nbCjJ"};